module.exports = __webpack_public_path__ + "img/group-placeholder-icon.0bc24fb2.svg";